
/**
 * 特殊节流，只执count及以内的次数
 * @param {Function} fn 
 * @param {Number} wait 
 */
var typeMap = {};
export const debounce = function (fn, type, count) {
    var time = null
    if(!typeMap[type]){
        typeMap[type] = 1
    }
    if (!typeMap[type] || typeMap[type] <= count) {
        typeMap[type] = typeMap[type] + 1
        clearTimeout(time)
        time = setTimeout(() => {
            typeMap[type] = 0
        }, 1000)
        return fn()
    } else {
        return false
    }

}